import { render } from "./LastTwelveMonthsSelector.vue?vue&type=template&id=204c52f8&ts=true"
import script from "./LastTwelveMonthsSelector.vue?vue&type=script&lang=ts"
export * from "./LastTwelveMonthsSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__